<template>
  <div>
    <div class="drop" @dragover.prevent @drop="onDrop">
      <label v-if="!value" class="btn display-inline">
        DRAG AND DROP OR
        <input type="file" name="value" @change="onChange" :accept="accept" />
      </label>
      <div class="hidden" v-else v-bind:class="{ value: true }">
        <a target="_blank" :href="fileUrl">{{ fileUrl }}</a>
        <el-button
          @click.stop="removeFile"
          class="remove-button"
          v-if="value"
          size="mini"
          icon="el-icon-delete"
          type="danger"
          title="Remove file"
        >
        </el-button>
      </div>
    </div>
    <attachment-preview
      v-if="fileUrl"
      class="attachment-preview"
      v-model="fileUrl"
    />
  </div>
</template>
<script>
import { Attachment, PublicAttachment } from '@/api'
import { getFileName } from '../../../common/js/imgproxy'

export default {
  props: {
    value: {},
    accept: {},
    keepOriginalFilename: { type: Boolean, default: false },
    isPublic: { type: Boolean, default: false }
  },
  data() {
    return {
      selectedAttachment: null
    }
  },
  methods: {
    getFileName,
    sendFile(files) {
      const data = new FormData()
      const file = files[0]
      data.append('file', file, file.name)
      data.append('keep_original_filename', this.keepOriginalFilename)
      return this.service
        .upload(data)
        .then(response => {
          this.uploadSuccess(response)
        })
        .catch(error => {
          this.uploadError(error)
        })
    },
    uploadSuccess(response) {
      this.$emit('input', response.data.id)
    },
    uploadError(error) {
      console.error(error, 'error while file uploading')
      this.$message({
        message: 'Error occurred while file uploading.',
        type: 'error'
      })
    },
    removeFile() {
      this.$emit('input', null)
    },
    onDrop: function(e) {
      e.stopPropagation()
      e.preventDefault()
      let files = e.dataTransfer.files
      this.sendFile(files)
    },
    onChange(e) {
      let files = e.target.files
      this.sendFile(files)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(id) {
        this.service.get({ id }).then(response => {
          this.selectedAttachment = response.data
        })
      }
    }
  },
  computed: {
    fileUrl() {
      return (
        this.selectedAttachment &&
        this.getFileName(this.selectedAttachment.file)
      )
    },
    service() {
      return this.isPublic ? PublicAttachment : Attachment
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 0;
  top: 0;
}

.drop {
  border: 2px dashed #ccc;
  padding: 40px;
  background-color: #fafafa;
  height: 100%;
  max-width: 600px;
  position: relative;
  width: 100%;
  text-align: center;
}

.drop img {
  max-width: 100%;
}
.attachment-preview {
  margin-top: 10px;
}
</style>
